import get from "lodash/get";
import parseJSON from "date-fns/parseJSON";
import { routeRegistry } from "../navigation/routeRegistry";
import { isInternalQflowEmail } from "./email";

// Where confined users land: the configure-data build-status step.
export const SETUP_REDIRECT_PATH = "/admin/company/configure-data/6";

// Same reduction FinalDataBuildPollingDiv polls with, taken from the
// unwrapped context dataStatus instead of the raw query payload.
const FIRST_BUILD_PROCESS_ENTRIES = [
    "1_core_generator",
    "6_on_hand_predictor_preprocess",
    "last_streaming_update",
    "4_task_generator",
];

export function isFirstBuildComplete(dataStatus, activeCrm) {
    const processingStatusNew = get(dataStatus, "processing_status_new", []);
    const buildProcesses = (Array.isArray(processingStatusNew) ? processingStatusNew : [])
        .filter((item) => FIRST_BUILD_PROCESS_ENTRIES.includes(item.statusEntry));
    const inProgress = buildProcesses.filter((item) => !item.status?.success);
    const buildComplete = buildProcesses.length > 0 && inProgress.length === 0;

    const crm = activeCrm === "hscrm" ? "hscrm" : "sfdc";
    const startedRaw = get(
        dataStatus, `processing_status.status_data_ingest.${crm}_ongoing_data.started`, null);
    const completedRaw = get(
        dataStatus, `processing_status.status_data_ingest.${crm}_ongoing_data.completed`, null);
    const started = startedRaw && parseJSON(startedRaw);
    const completed = completedRaw && parseJSON(completedRaw);

    return Boolean(buildComplete && started && completed && completed > started);
}

export function requiresSetupRoute(pathname) {
    const path = String(pathname || "");
    return routeRegistry.some((route) => (
        route.requiresSetup === true &&
        (path === route.path || path.startsWith(`${route.path}/`))
    ));
}

// Until a new customer's first data build completes, non-internal users are
// confined to the configuration/setup pages instead of wandering into
// analytics routes that render raw "could not be loaded" errors mid-build
// (canary finding 6c). Internal @qflow.ai users bypass for QA.
//
// Fails OPEN while the data status has not loaded (or predates the
// processing_status_new shape) — an existing customer must never be
// flash-redirected while the first fetch is in flight.
export function shouldConfineToSetup({ pathname, email, dataStatus, activeCrm }) {
    if (!requiresSetupRoute(pathname)) return false;
    if (isInternalQflowEmail(email)) return false;
    if (
        !dataStatus ||
        typeof dataStatus !== "object" ||
        Array.isArray(dataStatus) ||
        !Object.prototype.hasOwnProperty.call(dataStatus, "processing_status_new")
    ) {
        return false;
    }
    return !isFirstBuildComplete(dataStatus, activeCrm);
}
